import { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import VolverAlPanel from '../components/VolverAlPanel';
import './Alarmas.css';

function Alarmas() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const token = localStorage.getItem('token');

  const [configAlarmas, setConfigAlarmas] = useState([]);
  const [historialAlarmas, setHistorialAlarmas] = useState([]);
  const [sensores, setSensores] = useState([]);
  const [pisciculturas, setPisciculturas] = useState([]);
  const [pisciculturaSeleccionada, setPisciculturaSeleccionada] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [nuevaAlarma, setNuevaAlarma] = useState({
    IdSensor: '',
    TipoCondicion: 'mayor',
    ValorUmbral: '',
    TiempoSinLectura: ''
  });

  useEffect(() => {
    obtenerDatos();
  }, []);

  const obtenerDatos = async () => {
    try {
      const resConfig = await axios.get('https://iacloud.iapatagonia.cl/backend/config-alarmas', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const resHistorial = await axios.get('https://iacloud.iapatagonia.cl/backend/alarmas', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const resSensores = await axios.get('https://iacloud.iapatagonia.cl/backend/sensores', {
        headers: { Authorization: `Bearer ${token}` }
      });

      setConfigAlarmas(resConfig.data);
      setHistorialAlarmas(resHistorial.data);
      setSensores(resSensores.data);

      const piscisUnicas = [...new Set(resSensores.data.map(s => s.Piscicultura))];
      setPisciculturas(piscisUnicas);
    } catch (error) {
      console.error('Error al cargar datos:', error);
    }
  };

  const crearAlarma = async () => {
    try {
      await axios.post('https://iacloud.iapatagonia.cl/backend/config-alarmas', nuevaAlarma, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModalVisible(false);
      obtenerDatos();
    } catch (error) {
      console.error('Error al crear alarma:', error);
    }
  };

  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <VolverAlPanel />
      <div className="pagina-alarmas">
        <h2>🚨 Alarmas</h2>
        <p>Panel de alarmas activas, historial de eventos y configuración.</p>

        {usuario.rol === 'admin' && (
          <button className="btn-crear" onClick={() => setModalVisible(true)}>
            + Crear nueva alarma
          </button>
        )}

        <div className="seccion">
          <h3>🔧 Alarmas Configuradas</h3>
          <ul>
            {configAlarmas.map((a, i) => (
              <li key={i}>
                Sensor #{a.IdSensor} - {a.TipoCondicion} {a.ValorUmbral || a.TiempoSinLectura}
              </li>
            ))}
          </ul>
        </div>

        <div className="seccion">
          <h3>📋 Historial de Alarmas</h3>
          <ul>
            {historialAlarmas.map((h, i) => (
              <li key={i}>
                Sensor #{h.IdSensor} - {h.TipoFalla} - {new Date(h.Fecha).toLocaleDateString()}
              </li>
            ))}
          </ul>
        </div>

        {modalVisible && (
          <div className="modal-overlay" onClick={() => setModalVisible(false)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h3>➕ Nueva Alarma</h3>

              <label>Piscicultura:</label>
              <select
                value={pisciculturaSeleccionada}
                onChange={(e) => setPisciculturaSeleccionada(e.target.value)}
              >
                <option value="">Seleccione una piscicultura</option>
                {pisciculturas.map((p, i) => (
                  <option key={i} value={p}>{p}</option>
                ))}
              </select>

              <label>Sensor:</label>
              <select
                value={nuevaAlarma.IdSensor}
                onChange={(e) => setNuevaAlarma({ ...nuevaAlarma, IdSensor: e.target.value })}
              >
                <option value="">Seleccione un sensor</option>
                {sensores
                  .filter(s => !pisciculturaSeleccionada || s.Piscicultura === pisciculturaSeleccionada)
                  .map((s) => (
                    <option key={s.IdSensor} value={s.IdSensor}>
                      #{s.IdSensor} - {s.Modelo} ({s.TipoSensor}) - {s.Piscicultura}
                    </option>
                  ))}
              </select>

              <label>Tipo condición:</label>
              <select
                value={nuevaAlarma.TipoCondicion}
                onChange={(e) => setNuevaAlarma({ ...nuevaAlarma, TipoCondicion: e.target.value })}
              >
                <option value="mayor">Mayor que</option>
                <option value="menor">Menor que</option>
                <option value="sin_lectura">Sin lectura</option>
              </select>

              {nuevaAlarma.TipoCondicion !== 'sin_lectura' ? (
                <>
                  <label>Valor umbral:</label>
                  <input
                    type="number"
                    value={nuevaAlarma.ValorUmbral}
                    onChange={(e) => setNuevaAlarma({ ...nuevaAlarma, ValorUmbral: e.target.value })}
                  />
                </>
              ) : (
                <>
                  <label>Tiempo sin lectura (min):</label>
                  <input
                    type="number"
                    value={nuevaAlarma.TiempoSinLectura}
                    onChange={(e) => setNuevaAlarma({ ...nuevaAlarma, TiempoSinLectura: e.target.value })}
                  />
                </>
              )}

              <button onClick={crearAlarma} className="btn-confirmar">
                Crear
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Alarmas;
